<template>
  <span>
    <template v-if="checkNotificationStatus">
      <div class="session">

        <template v-if="isNewUserNotificationType">
          <SessionTimeOutNewUser @force-rerender="forceRerender" />
        </template>
        <template v-else>

          <SessionTimeOutOTP @force-rerender="forceRerender" />

        </template>
      </div>
    </template>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { sessionTimeoutNotificationType } from '../../store/modules/user/enums';
import SessionTimeOutNewUser from './SessionTimeOutNewUser.vue';
import SessionTimeOutOTP from './SessionTimeOutOTP.vue';

export default {
  components: {
    SessionTimeOutNewUser, SessionTimeOutOTP,
  },
  computed: {
    ...mapGetters({
      sessionNotifyStatus: 'user/sessionNotifyStatus',
    }),
    checkNotificationStatus() {
      return this.sessionNotifyStatus?.active;
    },
    isNewUserNotificationType() {
      return this.sessionNotifyStatus?.type === sessionTimeoutNotificationType.NEW_USER;
    },
  },
  methods: {
    forceRerender(val) {
      this.$emit('force-rerender', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.session {
    background-color: #00000054;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999999;
    display:flex
}

</style>
